var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#34C26D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81823 13.0915L6.84368 14.1169L10.9091 10.0588L10.9091 18.9097L12.3637 18.9097L12.3637 10.0588L16.4219 14.1242L17.4546 13.0915L11.6364 7.2733L5.81823 13.0915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessArrowup);
export default __webpack_public_path__ + "static/media/success_arrowup.8f8c0c7e0b8e4f7641acafb0ede27a5e.svg";
export { ForwardRef as ReactComponent };